var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 0H5.00037C2.25068 0 0.000488281 2.25019 0.000488281 4.99988V15.0001C0.000488281 17.7491 2.25068 20 5.00037 20H15.0001C17.7498 20 20 17.7491 20 15.0001V4.99988C20 2.25019 17.7498 0 15.0001 0ZM18.3333 15.0001C18.3333 16.8376 16.8386 18.3333 15.0001 18.3333H5.00037C3.16267 18.3333 1.6672 16.8376 1.6672 15.0001V4.99988C1.6672 3.16193 3.16267 1.66671 5.00037 1.66671H15.0001C16.8386 1.66671 18.3333 3.16193 18.3333 4.99988V15.0001Z",
    fill: "#198282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4175 5.83295C16.1078 5.83295 16.6674 5.27332 16.6674 4.58298C16.6674 3.89264 16.1078 3.33301 15.4175 3.33301C14.7271 3.33301 14.1675 3.89264 14.1675 4.58298C14.1675 5.27332 14.7271 5.83295 15.4175 5.83295Z",
    fill: "#198282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 5C7.23793 5 5 7.23818 5 9.99988C5 12.7606 7.23793 15.0002 9.99988 15.0002C12.761 15.0002 14.9998 12.7606 14.9998 9.99988C14.9998 7.23818 12.761 5 9.99988 5ZM9.99988 13.3335C8.15915 13.3335 6.66671 11.8411 6.66671 9.99988C6.66671 8.15866 8.15915 6.66671 9.99988 6.66671C11.8406 6.66671 13.333 8.15866 13.333 9.99988C13.333 11.8411 11.8406 13.3335 9.99988 13.3335Z",
    fill: "#198282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.8146524161e166d8c4795ee871cb892c.svg";
export { ForwardRef as ReactComponent };